<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="authService.isAdmin() || authService.isFinanceAdmin()" (click)="showSearchResult = false"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console</a></small>
    <small *ngIf="authService.isDeveloper()" (click)="showSearchResult = false"><a [routerLink]="['/rental-fleet']" class="text-secondary">Developer Portal</a></small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="onNavSearchClick();">/ Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row align-items-center justify-content-center no-gutters">
  <div class="col-12">
    <app-search-results [locationList]="searchedLocationList" [servicePackageList]="searchedServicePackageList"
      [vehicleList]="searchedVehicleList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult" class="row align-items-center justify-content-center home-container no-gutters">
  <div class="col pl-0 pr-0">
    <div *ngIf="authService.isAdmin()" class="row text-center ml-1 mr-1 mt-4">
      <div *ngIf="accountCategory == 'RENTAL_FLEET'" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/b2b.png" alt="Account Management"
          routerLink="/account-management" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Account Management</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage vehicles and packages</span> <!-- Manage vehicles, packages and locations -->
      </div>
      <div *ngIf="accountType == 'VEHICLE_SERVICE_PROVIDER'" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/user.png" alt="Account Management"
          routerLink="/mobility-service" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Account Management</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage vehicles, packages and locations</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/usage.png" alt="Usage" routerLink="/usage" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Usage</span><br>
        <span class="font-nissan-brand-w01-light font-12">View service usage</span>
      </div> -->
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/usage.png" alt="invoices" routerLink="/invoices" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Invoices</span><br>
        <span class="font-nissan-brand-w01-light font-12">View invoices</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/developer-access.png" alt="Developer Access"
          (click)="openDeveloperAccess()" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer Access</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and manage API access</span>
      </div> -->
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/users.png" alt="Admin Roles" routerLink="/admin-roles" /><br>
        <span class="font-nissan-brand-w01-bold font-14">User Roles</span><br>
        <span class="font-nissan-brand-w01-light font-12">Add or manage users</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/gear.png" alt="Settings" routerLink="/settings" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Settings</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage account</span> <!--  & location settings -->
      </div>
      <div *ngIf="env.SHOW_STREAMING" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/streaming.png" alt="Streaming" routerLink="/streaming" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Streaming Data</span><br>
        <span class="font-nissan-brand-w01-light font-12">View Stream Data</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/journey/vehicle-journey.png" alt="Streaming" routerLink="/vehicle-journey" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Vehicle Journey</span><br>
        <span class="font-nissan-brand-w01-light font-12">Vehicle Journey Data</span>
      </div> -->
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/journey/status.png" alt="Streaming" routerLink="/vehicle-status" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Vehicle Status</span><br>
        <span class="font-nissan-brand-w01-light font-12">Vehicle Status Data</span>
      </div> -->
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/dashboard.png" alt="accounts"
          routerLink="/commercial-fleet-dashboard" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Dashboard</span><br>
        <span class="font-nissan-brand-w01-light font-12">View fleet status and insights</span>
      </div> -->
    </div>
    <div *ngIf="authService.isDeveloper()" class="row text-center ml-1 mr-1 mt-4 no-gutters">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/developer-access.png" alt="Developer Access"
          (click)="apiAccess.openDeveloperAccess()" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer Access</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and manage API access</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/developer-access.png" alt="Swagger"
          routerLink="/swagger-ui"/><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer APIs</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and try APIs</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/faq/faq.png" alt="FAQ" routerLink="/faq" /><br>
        <span class="font-nissan-brand-w01-bold font-14">FAQ</span><br>
        <span class="font-nissan-brand-w01-light font-12">Check Common Queries</span>
      </div>
      <!-- <div *ngIf="isShowKinesisData()" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/developer-access.png" alt="StreamData" routerLink="/vehicle-trips" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Vehicle Journey</span><br>
        <span class="font-nissan-brand-w01-light font-12">View Vehicle Journey Data</span>
      </div> -->
    </div>
    <div *ngIf="authService.isFinanceAdmin()" class="row text-center ml-1 mr-1 mt-4 no-gutters">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/usage.png" alt="invoices" routerLink="/invoices" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Invoices</span><br>
        <span class="font-nissan-brand-w01-light font-12">View invoices</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
    </div>
  </div>
</div>



<!-- Modal API Access -->
<developer-access #apiAccess></developer-access>

<!-- TnC Model -->
<ncc-tnc></ncc-tnc>